import { TFunction } from 'i18next';

export type OrdersListTranslations = {
  stopOrderFilterCancelled: string;
  stopOrderFilterExecuted: string;
  stopOrderFilterPlaced: string;
  stopOrderTitle: string;
  stopOrderBuyTitle: string;
  stopOrderSellTitle: string;
  stopOrderTargetTitle: string;
  stopOrderTargetSubtitle: string;
};

const ordersListTranslations: OrdersListTranslations = {
  stopOrderFilterCancelled: 'stop_order_filter_cancelled',
  stopOrderFilterExecuted: 'stop_order_filter_executed',
  stopOrderFilterPlaced: 'stop_order_filter_placed',
  stopOrderTitle: 'stop_orders_title_@tenant',
  stopOrderBuyTitle: 'stop_order_buy_title_@tenant',
  stopOrderSellTitle: 'stop_order_sell_title_@tenant',
  stopOrderTargetTitle: 'stop_order_target_title',
  stopOrderTargetSubtitle: 'stop_order_target_subtitle_@tenant',
};

export const getOrdersListTranslations = (
  t: TFunction,
): OrdersListTranslations => {
  return Object.entries(ordersListTranslations).reduce((acc, [key, value]) => {
    acc[key as keyof OrdersListTranslations] = t(value);

    return acc;
  }, {} as OrdersListTranslations);
};
